<template>
  <modal
    :title="$t('ReprocessOrder.title')"
    @close-request="onModalClose()"
    closable
  >
    <transition name="fade">
      <div class="container-fluid">
        <p>{{$t('ReprocessOrder.confirmation_details')}}</p>
        <div class="border p-1 my-2">
          <p>
            <strong>{{$t('ReprocessOrder.order_id') + ': ' + originalOrder['.key']}}</strong> <br>
            <strong v-if="originalOrder.cancelReason">{{$t('ReprocessOrder.cancel_reason') + ': ' + originalOrder.cancelReason}}</strong> <br>
            <strong>{{$t(`ReprocessOrder.date`) + ': ' + getDate(originalOrder.creationDate)}}</strong> <br>
          </p>
        </div>
        <button class="btn btn-kne-orange" @click="onReprocessOrder(orderId, originalOrder)">{{$t('General.confirm')}}</button>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import { db, dbArchives2 } from '../../../../firebase'
import RegularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import RegularTextarea from '../../basic-components/regularTextarea.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularInputNumber from '../../basic-components/regularInputNumber.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'

import DeliveryLocationDetails from '../Other-components/DeliveryLocationDetails.vue'

export default {
  name: 'ReprocessOrderModal',
  components: {
    RegularDatalistDriver,
    RegularTextarea,
    RegularInput,
    RegularInputNumber,
    HoverToolTip,
    DeliveryLocationDetails,
    Modal
  },

  props: {
    orderId: {
      tyoe: String,
      required: true
    },

    isArchived: {
      type: Boolean,
      required: false
    },

    originalOrder: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      statusTypes: {
        processing: 'Processing'
      }
    }
  },

  methods: {
    async onReprocessOrder (orderId, order) {
      if (!this.isArchived) return

      let orderCopy = order
      this.formatOrder(orderCopy)

      await db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).set(orderCopy).then(
        this.removeOrderFromArchive(orderId)
      ).catch(error => {
        console.log('error in the system', error)
      })

      this.onModalClose()
      this.sendToNewRouter('OrderCurrent')
    },

    removeOrderFromArchive (orderId) {
      dbArchives2.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).set({})
      .catch(error => {
        console.log(error)
      })
    },

    formatOrder (order) {
      delete order['.key']
      order.status = this.statusTypes.processing
      return order
    },

    sendToNewRouter (path) {
      this.$router.push({name: `${path}`})
    },

    onModalClose () {
      this.emitClose()
    },

    emitClose () {
      this.$emit('closeModal')
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  },
  computed: {
    uid () {
      return this.$store.state.user.uid
    },

    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>

<style>

</style>
